<template>
  <span class="icon-btn" @click="handleClick">
    <span
      v-if="!$slots.default"
      :class="[suffix, icon]"
      :style="{
        fontSize: `${size}px`,
        fontWeight: fontWeight,
      }"
    ></span>
    <!--  使用插槽来兼容非 iconfont 图标，比如 elementui icon  -->
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: "iconBtn",
  props: {
    suffix: {
      // 想用 element 的图标，就传空，ex: suffix=""
      type: String,
      default: "joinmc",
    },
    icon: {
      type: String,
      required: false,
    },
    size: {
      type: Number,
      default: 16,
    },
    fontWeight: {
      type: [Number, String],
      default: 500,
    },
  },
  methods: {
    handleClick(event) {
      this.$emit("click", event);
    },
  },
};
</script>

<style scoped lang="scss">
.icon-btn {
  height: 24px;
  width: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all var(--mc-transition-duration) var(--mc-transition-timing-function);
  .joinmc {
    display: inline-flex;
    align-items: center;
    font-weight: 500;
    color: var(--mc-primary-text-color);
    transition: all var(--mc-transition-duration) var(--mc-transition-timing-function);
  }

  &:hover {
    background: rgba(216, 216, 216, 0.5);
    border-radius: 4px;
    transition: inherit;
    .joinmc {
      color: var(--mc-color-primary);
      transition: all var(--mc-transition-duration) var(--mc-transition-timing-function);
    }
  }
}
</style>
